__turbopack_context__.v({
  "container": "_95ysbW_container",
  "description": "_95ysbW_description",
});
